export const GET_SHOES_DATA_REQUEST = "GET_SHOES_DATA_REQUEST";
export const GET_SHOES_DATA_SUCCESS = "GET_SHOES_DATA_SUCCESS";
export const GET_SHOES_DATA_FAILURE = "GET_SHOES_DATA_FAILURE";
